import Vue from '@vue/compat';
import qkHighlightjs from './highlight.js';
import articleFooterOptions from './article-footer.js';
import articleReportOptions from './article-report.js';
import commentsOptions from './comments.js';
import downloadBoxOptions from './download-box.js';
import episodePlayerWrapOptions from './episode-player-wrap.js';
import playerWrapOptions from './player-wrap.js';
import postAuthorOptions from './post-author.js';
import postMetaOptions from './post-meta.js';
import videoChaptersOptions from './video-chapters.js';
import widgetDownloadBoxOptions from './widget-download-box.js';

function mountPage(selector, options) {
  if (!document.querySelector(selector)) return null;
  return new Vue({ el: selector, ...options });
}

qkHighlightjs();

window.qkDownloadBox = mountPage('#download-box', downloadBoxOptions);
window.qkWidgetDownloadBox = mountPage('#qk-download-box', widgetDownloadBoxOptions);
window.qkArticlereport = mountPage('.article-report', articleReportOptions);
window.qkArticleFooter = mountPage('.article-footer', articleFooterOptions);
window.qkComments = mountPage('#comments', commentsOptions);
window.singleMeta = mountPage('.post-meta', postMetaOptions);
window.postAuthor = mountPage('.qk_widget_author', postAuthorOptions);
window.videoChapters = mountPage('#video-chapters', videoChaptersOptions);
window.episodePlayerWrap = mountPage('.single-episode .qk-player-wrap', episodePlayerWrapOptions);
window.playerWrap = mountPage('#qk-player-wrap', playerWrapOptions)
    || mountPage('.single-article-video .qk-player-wrap', playerWrapOptions)
    || mountPage('.single-post .qk-player-wrap', playerWrapOptions);

if (window.playerWrap) {
    window.playAtIndex = (index) => window.playerWrap.playAtIndex(index);
}

export {
  articleFooterOptions,
  articleReportOptions,
  commentsOptions,
  downloadBoxOptions,
  episodePlayerWrapOptions,
  playerWrapOptions,
  postAuthorOptions,
  postMetaOptions,
  videoChaptersOptions,
  widgetDownloadBoxOptions,
};
